import { Theme } from "@material-ui/core";

const styles = (theme: Theme) =>
  ({
    mobileHeader: {
      background: "#FFF",
      borderRadius: "26px 26px 0 0",
      boxShadow: "0 -1px 2px 3px rgba(224,224,224,0.5)",
      padding: "12px 0 16px 0",
      position: "fixed",
      width: "calc(100% - 0px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
      left: 0,
      bottom: 0,
    },
    mobileButton: {
      padding: "0 4px",
      marginLeft: 8,
      borderRadius: 12,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      "& > span": {
        lineHeight: 1,
      },
    },
    mobileLabelButton: {
      minWidth: 50,
      height: 50,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      "& > p": {
        textTransform: "none",
        fontSize: 11,
        color: "black",
        fontFamily: "Mulish, sans-serif",
      },
      "& svg": {
        padding: "4px",
        "&  > g, & > path": {
          fill: theme.palette.secondary.main,
        },
      },
    },
    noTitle: {
      "&:hover": {
        "&:after": { opacity: 0, padding: 0 },
      },
    },
    active: {
      background: 'linear-gradient(62deg, '+theme.palette.secondary.light+' 1%, '+theme.palette.secondary.main+' 98%)',
      boxShadow: "0 2px 13px 1px rgba(211,211,211, 0.2)",
      "& svg": {
        "&  > g": {
          fill: "white",
        },
      },
    },
    iconMaterial: {
      padding: 0 + " !important",
      fontSize: 33,
    },
    icon: {
      minWidth: 20,
      marginRight: 12,
      display: "flex",
      alignItems: "center",
      "& > svg": {
        fill: theme.palette.secondary.main,
        "& > g": {
          fill: theme.palette.secondary.main,
          "& > g": {
            stroke: theme.palette.secondary.main,
          },
        },
      },
    },
    drawer: {
      minWidth: "50vw",
    },
  } as any);

export default styles;
